// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3dt86","icons":"footer-module--icons--24QNx"};